import type { SorterResult } from "antd/lib/table/interface";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import type { HostConfigurationEntity } from "src/app/features/HostConfiguration/types/HostConfigurationEntity";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "../../../../../components";
import {
    displayDateTimeValue,
    displayStatusValue,
} from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";

export const HostConfigurationsTable: FC<ResourceTableProps<HostConfigurationEntity>> = ({
    onStateChanged,
    onRowSelectionChange,
    datasource,
    resource,
}) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<HostConfigurationEntity>): ExtendedColumnsType<HostConfigurationEntity>[] => {
            return [
                {
                    title: t("genericTable.column.id"),
                    key: "id",
                    dataIndex: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("genericTable.column.name"),
                    key: "name",
                    dataIndex: "name",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "name" ? sortInfo.order : null,
                },
                {
                    title: t("genericTable.column.status"),
                    key: "status",
                    dataIndex: "status",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "status" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
                {
                    title: t("genericTable.column.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "changed" ? sortInfo.order : null,
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: HostConfigurationEntity) =>
        navigate(`${BASE_PATH}/${ResourceName.HOST_CONFIGURATIONS}/${FORM_ACTION.EDIT}/${record.id}`);

    return (
        (datasource && (
            <GenericTable<HostConfigurationEntity>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="hostConfigurationsXml_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: HostConfigurationEntity) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
